import { IS_CONNECT_CARRIER_LOCAL_OR_CI_CYPRESS } from '@connect-carrier/harness/constants';
import { setSelectedCustomer } from '@connect-carrier/harness/customer';
import { CustomerListOutput } from '@connect-carrier/hooks/useFetchCustomerList';
import { fetchFromUploadOrigin } from '@connect-carrier/util/fetch';
import { jsonStringify } from '@utils/json';

interface CustomerResponseProps {
  status: string;
  message: string;
  images: [
    {
      tenantCode: string;
      tenantImage: string;
      tenantName: string;
      tenantId: string;
    },
  ];
}

// ts-unused-exports:disable-next-line
export const fetchCustomerImageList = async (
  customerList: CustomerListOutput[],
): Promise<CustomerListOutput[]> => {
  const transformedCustomerList = customerList.map((customer) => ({
    tenantName: customer.tenantName,
    tenantCode: customer.tenantCode,
    tenantId: customer.tenantId,
  }));
  if (IS_CONNECT_CARRIER_LOCAL_OR_CI_CYPRESS) {
    return [];
  }
  if (transformedCustomerList.length) {
    const response = await fetchFromUploadOrigin(`/v0/icons/load/`, {
      method: 'POST',
      body: jsonStringify({
        tenantlist: transformedCustomerList,
      }),
      headers: {
        'Content-Type': 'application/json',
      },
    });
    const data = await response.json();
    const updatedCustomerList = customerList.map((customer) => {
      const matchingImage = data?.images?.find(
        (image: CustomerResponseProps['images'][number]) =>
          image.tenantId === customer.tenantId,
      );
      if (matchingImage) {
        return {
          ...customer,
          tenantImage: matchingImage.tenantImage,
        };
      }
      return customer;
    });
    if (updatedCustomerList.length > 0) {
      setSelectedCustomer(updatedCustomerList[0]);
    }
    return updatedCustomerList;
  }

  return [];
};
